import { bulkCancelTasks } from '@dispatch/shared/services';
import { TaskStatus } from '@dispatch/shared/types';
import { useMutation, useQueryClient } from 'react-query';
import { invalidateTaskCaches } from './invalidateTaskCaches';

type TaskStatusAction = Exclude<TaskStatus, 'notstarted'>;
type BulkCancelData = {
  taskIds: string[];
  status: TaskStatusAction;
  reason?: string;
};

export function useBulkCancelTasks(
  onSuccess?: () => void,
  onError?: () => void,
  onSettled?: () => void
) {
  const queryClient = useQueryClient();

  return useMutation(
    async (data: BulkCancelData) => {
      const { taskIds, status, reason } = data;
      return bulkCancelTasks(taskIds, status, reason);
    },
    {
      onSuccess,
      onError,
      onSettled: (_data, _error, variables) => {
        onSettled && onSettled?.();
        invalidateTaskCaches(queryClient, variables?.taskIds);
      },
    }
  );
}
